import { render, staticRenderFns } from "./AmountIoChipCard.vue?vue&type=template&id=734ec2b2&"
import script from "./AmountIoChipCard.vue?vue&type=script&lang=js&"
export * from "./AmountIoChipCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports